import { AI_ASSISTANT_GUIDELINE_FULL_VIEW_Z_INDEX } from 'app/pages/loanApplication/components/AiAssistant/AiAssistant.constants';

import { COLOR_PALETTE } from 'constants/ui';

export const drawerRootStyles = {
  zIndex: AI_ASSISTANT_GUIDELINE_FULL_VIEW_Z_INDEX,
};

export const drawerPaperStyles = {
  width: '480px',
  maxWidth: '100%',
  zIndex: AI_ASSISTANT_GUIDELINE_FULL_VIEW_Z_INDEX,
};

export const drawerPaperProps = { sx: drawerPaperStyles };

export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: '16px 20px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.light}`,
  backgroundColor: COLOR_PALETTE.BLUE[1],
  gap: '12px',
};

export const headerLeftStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  flex: 1,
  minWidth: 0,
};

export const iconStyles = {
  color: COLOR_PALETTE.BLUE[6],
  width: 24,
  height: 24,
  flexShrink: 0,
  marginTop: '2px',
};

export const headerTextContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
  minWidth: 0,
};

export const sourceTextStyles = {
  color: ({ palette }) => palette.text.placeholder,
};

export const sectionTextStyles = {
  color: COLOR_PALETTE.BLUE[7],
  fontWeight: 600,
};

export const titleTextStyles = {
  color: ({ palette }) => palette.text.dark,
};

export const closeButtonStyles = {
  padding: '4px',
  minWidth: 'auto',
  color: ({ palette }) => palette.text.placeholder,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  transition: 'background-color 0.2s ease',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.secondary,
  },
};

export const closeIconStyles = {
  color: ({ palette }) => palette.text.placeholder,
};

export const contentStyles = {
  flex: 1,
  overflow: 'auto',
  padding: '20px',
};

export const loadingContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '200px',
};

export const guidelineTextStyles = {
  color: ({ palette }) => palette.text.dark,
  lineHeight: 1.7,
  whiteSpace: 'pre-wrap',
};

export const footerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: '12px 20px',
  borderTop: ({ palette }) => `1px solid ${palette.border.light}`,
  gap: '8px',
};
